// extracted by mini-css-extract-plugin
module.exports = {"form":"perform-password-reset_form_31JI8"};